import * as Blockly from 'blockly/core';
import 'blockly/python';

Blockly.Blocks['basket_choice'] = {
    init: function () {
        
       this.appendDummyInput('basket_chooser')
            .appendField(new Blockly.FieldDropdown([
            ["Basket 1","basket1"],
            ["Basket 2","basket2"]]), "basket_selection") 
        
     
        this.setStyle("dashboards")
   
        
       
  
  
    },
   
  }